import { createPortal } from "react-dom";
import styles from './fixedPortal.module.scss';

type Props = {
	children: React.ReactNode
}

export const FixedPortal = ({ children }: Props) => {
	const component = (
		<div className={styles.container}>
			{children}
		</div>
	)

	return createPortal(component, document.body);
}
